import React, { ChangeEventHandler, useCallback, useEffect, useState } from 'react';
import { RadioFilterProps } from './interfaces';
import { RadioButtonGroup } from '@shared/UI';
import { useRadioFilterQuery } from './lib';
import classNames from 'classnames';
import './RadioFilter.scss';

export const RadioFilter: React.FC<RadioFilterProps> = (props) => {
    const { options, value, setValue, className, queryName, name, initialOption } = props;

    const { queryRadioOption, setQueryRadioOption } = useRadioFilterQuery({
        queryName,
        initialRadioOption: initialOption,
        allowedValues: options.map((option) => option.value),
    });

    const [currentOption, setCurrentOption] = useState<string>(queryRadioOption);

    const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(({ target: { value: val } }) => {
        setCurrentOption(val);
    }, []);

    useEffect(() => {
        setValue(currentOption);
        setQueryRadioOption(currentOption);
    }, [currentOption, setQueryRadioOption]);

    return (
        <RadioButtonGroup
            name={name || queryName}
            options={options}
            defaultValue={currentOption}
            value={value}
            onChange={onChange}
            className={classNames('feature-radio-filter', className)}
        />
    );
};
